import useFetcher from 'app/_utils/data/useFetcher';

import useSWR from 'swr';
export type LeaderSystemInfo = {
  items: LeaderSystemItem[];
  count: number;
};
export interface LeaderSystemItem {
  apiPort: number;
  BUILD: Build;
  distMode: string;
  onlineDiag: boolean;
  guid: string;
  license: License;
  isCriblSandbox: boolean;
  isFipsEnabled: boolean;
  hasCloudWorkspace: boolean;
  openssl: object;
  isFedRampEnabled: boolean;
  insightsEnabled: boolean;
}
export type Build = {
  VERSION: string;
  BRANCH: string;
  TIMESTAMP: string;
};
export type LicenseLimits = {
  rbac?: number;
  [key: string]: number | undefined;
};
export type License = {
  type: string;
  isRegistered: boolean;
  limits: LicenseLimits;
  isSplunkApp: boolean;
};

export const useGetLeaderSystemInfo = ({ leaderFQDN }: { leaderFQDN: string }): ReturnType<
  typeof useSWR<LeaderSystemInfo, unknown>
> => {
  const leaderSystemInfoUrl = leaderFQDN ? `https://${leaderFQDN}/api/v1/system/info/cribl` : null;
  const { fetcher } = useFetcher();

  return useSWR(leaderSystemInfoUrl, (url: string) => fetcher<LeaderSystemInfo>(url, { method: 'GET' }), {
    revalidateOnFocus: false,
  });
};
